import { t } from "i18next";

export enum SystemRole {
    Administrator = 'Administrator',
    Physician = 'Physician'
}

export const getSystemRoleLabel = (role: SystemRole): string => {
    switch (role) {
        case SystemRole.Administrator:
            return t('roles.systemRoles.administrator');
        case SystemRole.Physician:
            return t('roles.systemRoles.physician');
    }
};
